export default "__VITE_ASSET__cd7e45aa__"